export default {
  methods: {
    autoScroll: function () {
      setTimeout(function () {
        let elm = document.documentElement
        window.scroll(0, (elm.scrollHeight - elm.clientHeight))
      }, 10)
    },
    displayPrefName: function (pref) {
      if (pref === '') {
        return ''
      }
      for (let key in this.prefs) {
        if (this.prefs.hasOwnProperty(key)) {
          if (this.prefs[key].id === pref) {
            return this.prefs[key].name
          }
        }
      }
    },
    displayGender: function (gender) {
      if (Number(gender) === this.genderConst.man) {
        return '男性'
      }
      if (Number(gender) === this.genderConst.woman) {
        return '女性'
      }
      return ''
    },
    toDoubleDigits: function (num) {
      num += ''
      if (num.length === 1) {
        num = `0${num}`
      }
      return num
    },
    displayUserIconClass: function (setGender) {
      if (setGender) {
        if (setGender === this.genderConst.man) {
          return 'is-gender__man'
        }
        if (setGender === this.genderConst.woman) {
          return 'is-gender__woman'
        }
      }
      return ''
    },
    displayIconName: function (setName) {
      if (setName) {
        return `${setName}さん`
      }
      return 'あなた'
    },
    displayVisivilityPassword: function (password) {
      if (password) {
        let dot = ''
        for (let n = 1; n <= password.length; n++) {
          dot += '●'
        }
        return dot
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/functionsMixin.js